import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { EventContentDetailPageRoutingModule } from "./event-content-detail-routing.module";
import { EventContentDetailPage } from "./event-content-detail.page";
import { PopoverModule } from "src/app/components/popover/popover.module";
import { ToReferentModule } from "src/app/pipes/to-referent/to-referent.module";
import { LinebreaksModule } from "src/app/pipes/linebreaks/linebreaks.module";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    EventContentDetailPageRoutingModule,
    PopoverModule,
    ToReferentModule,
    LinebreaksModule,
    TranslateModule,
  ],
  declarations: [EventContentDetailPage],
})
export class EventContentDetailPageModule {}
